module.exports = __webpack_public_path__ + "img/content3.0b05efad.png";